import { useCallback } from 'react'
import { createGlobalState } from 'react-use'

export const useIsGameStarted = createGlobalState<boolean>(false)

export function useGameManager() {
  const [isGameStarted, setIsGameStarted] = useIsGameStarted()
  const start = useCallback(() => setIsGameStarted(true), [setIsGameStarted])
  const reset = useCallback(() => setIsGameStarted(false), [setIsGameStarted])

  return { isGameStarted, start, reset }
}
